import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AuditComplianceTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedEventType, setSelectedEventType] = useState('');
  const [selectedSeverity, setSelectedSeverity] = useState('');

  const auditLogs = [
    {
      id: 'AUD001',
      timestamp: '26.11.2025 19:05:32',
      user: 'Dr. Anna Schmidt',
      userId: 'USR001',
      action: 'Benutzerrolle geändert',
      details: 'Rolle von "Sachbearbeiter" zu "Supervisor" für Benutzer Michael Weber geändert',
      eventType: 'Benutzerverwaltung',
      severity: 'Mittel',
      ipAddress: '192.168.1.45',
      status: 'Erfolgreich'
    },
    {
      id: 'AUD002',
      timestamp: '26.11.2025 18:52:18',
      user: 'System',
      userId: 'SYSTEM',
      action: 'Automatische Sicherung',
      details: 'Tägliche Systemsicherung erfolgreich abgeschlossen (12.4 GB)',
      eventType: 'System',
      severity: 'Niedrig',
      ipAddress: 'localhost',
      status: 'Erfolgreich'
    },
    {
      id: 'AUD003',
      timestamp: '26.11.2025 18:45:09',
      user: 'Michael Weber',
      userId: 'USR002',
      action: 'Massenexport durchgeführt',
      details: '1.247 Kundendatensätze nach Excel exportiert',
      eventType: 'Datenexport',
      severity: 'Hoch',
      ipAddress: '192.168.1.67',
      status: 'Erfolgreich'
    },
    {
      id: 'AUD004',
      timestamp: '26.11.2025 18:30:45',
      user: 'Unbekannt',
      userId: 'N/A',
      action: 'Fehlgeschlagener Anmeldeversuch',
      details: 'Mehrfache fehlgeschlagene Anmeldeversuche für Benutzer "admin" - Konto gesperrt',
      eventType: 'Sicherheit',
      severity: 'Kritisch',
      ipAddress: '203.0.113.42',
      status: 'Fehlgeschlagen'
    },
    {
      id: 'AUD005',
      timestamp: '26.11.2025 18:15:22',
      user: 'Sarah Müller',
      userId: 'USR003',
      action: 'Kundenprofil gelöscht',
      details: 'Kundenprofil KUN-2024-8765 dauerhaft gelöscht (DSGVO-Anfrage)',
      eventType: 'Datenverwaltung',
      severity: 'Hoch',
      ipAddress: '192.168.1.89',
      status: 'Erfolgreich'
    },
    {
      id: 'AUD006',
      timestamp: '26.11.2025 17:58:11',
      user: 'Dr. Anna Schmidt',
      userId: 'USR001',
      action: 'Systemkonfiguration geändert',
      details: 'Sitzungs-Timeout von 20 auf 30 Minuten erhöht',
      eventType: 'Konfiguration',
      severity: 'Mittel',
      ipAddress: '192.168.1.45',
      status: 'Erfolgreich'
    },
    {
      id: 'AUD007',
      timestamp: '26.11.2025 17:30:05',
      user: 'Julia Hoffmann',
      userId: 'USR005',
      action: 'Compliance-Bericht generiert',
      details: 'DSGVO-Compliance-Bericht für Q4 2025 erstellt',
      eventType: 'Berichterstattung',
      severity: 'Niedrig',
      ipAddress: '192.168.1.102',
      status: 'Erfolgreich'
    },
    {
      id: 'AUD008',
      timestamp: '26.11.2025 16:45:33',
      user: 'System',
      userId: 'SYSTEM',
      action: 'Datenbankwartung',
      details: 'Automatische Indexoptimierung durchgeführt',
      eventType: 'System',
      severity: 'Niedrig',
      ipAddress: 'localhost',
      status: 'Erfolgreich'
    }
  ];

  const eventTypeOptions = [
    { value: '', label: 'Alle Ereignistypen' },
    { value: 'Benutzerverwaltung', label: 'Benutzerverwaltung' },
    { value: 'Sicherheit', label: 'Sicherheit' },
    { value: 'Datenverwaltung', label: 'Datenverwaltung' },
    { value: 'Datenexport', label: 'Datenexport' },
    { value: 'Konfiguration', label: 'Konfiguration' },
    { value: 'System', label: 'System' },
    { value: 'Berichterstattung', label: 'Berichterstattung' }
  ];

  const severityOptions = [
    { value: '', label: 'Alle Schweregrade' },
    { value: 'Kritisch', label: 'Kritisch' },
    { value: 'Hoch', label: 'Hoch' },
    { value: 'Mittel', label: 'Mittel' },
    { value: 'Niedrig', label: 'Niedrig' }
  ];

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'Kritisch':
        return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300';
      case 'Hoch':
        return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300';
      case 'Mittel':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300';
      case 'Niedrig':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300';
      default:
        return 'bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300';
    }
  };

  const filteredLogs = auditLogs?.filter(log => {
    const matchesSearch = log?.action?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         log?.user?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
                         log?.details?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesEventType = !selectedEventType || log?.eventType === selectedEventType;
    const matchesSeverity = !selectedSeverity || log?.severity === selectedSeverity;
    return matchesSearch && matchesEventType && matchesSeverity;
  });

  return (
    <div className="space-y-6">
      {/* Statistics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-slate-600 dark:text-slate-400">Ereignisse heute</div>
              <div className="text-2xl font-bold text-slate-900 dark:text-slate-100 mt-1">247</div>
            </div>
            <div className="w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
              <Icon name="Activity" size={24} className="text-blue-600 dark:text-blue-400" />
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-slate-600 dark:text-slate-400">Kritische Ereignisse</div>
              <div className="text-2xl font-bold text-red-600 dark:text-red-400 mt-1">3</div>
            </div>
            <div className="w-12 h-12 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <Icon name="AlertTriangle" size={24} className="text-red-600 dark:text-red-400" />
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-slate-600 dark:text-slate-400">Fehlgeschlagene Aktionen</div>
              <div className="text-2xl font-bold text-orange-600 dark:text-orange-400 mt-1">12</div>
            </div>
            <div className="w-12 h-12 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center">
              <Icon name="XCircle" size={24} className="text-orange-600 dark:text-orange-400" />
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-sm text-slate-600 dark:text-slate-400">Compliance-Status</div>
              <div className="text-2xl font-bold text-emerald-600 dark:text-emerald-400 mt-1">98%</div>
            </div>
            <div className="w-12 h-12 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
              <Icon name="Shield" size={24} className="text-emerald-600 dark:text-emerald-400" />
            </div>
          </div>
        </div>
      </div>
      {/* Filters */}
      <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-4">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
          <div className="lg:col-span-2">
            <Input
              type="search"
              placeholder="Protokolle durchsuchen (Aktion, Benutzer, Details)..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
            />
          </div>
          <Select
            placeholder="Ereignistyp"
            options={eventTypeOptions}
            value={selectedEventType}
            onChange={setSelectedEventType}
          />
          <Select
            placeholder="Schweregrad"
            options={severityOptions}
            value={selectedSeverity}
            onChange={setSelectedSeverity}
          />
        </div>
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-slate-200 dark:border-slate-700">
          <div className="text-sm text-slate-600 dark:text-slate-400">
            {filteredLogs?.length} von {auditLogs?.length} Einträgen
          </div>
          <div className="flex gap-2">
            <Button variant="outline" size="sm" iconName="Download">
              CSV exportieren
            </Button>
            <Button variant="outline" size="sm" iconName="FileText">
              PDF-Bericht
            </Button>
          </div>
        </div>
      </div>
      {/* Audit Logs Table */}
      <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50 dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Zeitstempel
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Benutzer
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Aktion
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Ereignistyp
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Schweregrad
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-slate-700 dark:text-slate-300 uppercase tracking-wider">
                  Aktionen
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
              {filteredLogs?.map((log) => (
                <tr key={log?.id} className="hover:bg-slate-50 dark:hover:bg-slate-700/50 transition-colors">
                  <td className="px-4 py-4">
                    <div className="text-sm font-medium text-slate-900 dark:text-slate-100">
                      {log?.timestamp}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                      ID: {log?.id}
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="text-sm font-medium text-slate-900 dark:text-slate-100">
                      {log?.user}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                      {log?.userId}
                    </div>
                    <div className="text-xs text-slate-400 dark:text-slate-500">
                      IP: {log?.ipAddress}
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <div className="text-sm font-medium text-slate-900 dark:text-slate-100 mb-1">
                      {log?.action}
                    </div>
                    <div className="text-xs text-slate-600 dark:text-slate-400 max-w-md">
                      {log?.details}
                    </div>
                  </td>
                  <td className="px-4 py-4">
                    <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-800 dark:bg-slate-700 dark:text-slate-300">
                      {log?.eventType}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getSeverityColor(log?.severity)}`}>
                      {log?.severity}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${
                      log?.status === 'Erfolgreich' ?'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300' :'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300'
                    }`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${
                        log?.status === 'Erfolgreich' ? 'bg-emerald-600' : 'bg-red-600'
                      }`} />
                      {log?.status}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <button className="p-1.5 hover:bg-slate-100 dark:hover:bg-slate-600 rounded transition-colors">
                      <Icon name="Eye" size={16} className="text-slate-600 dark:text-slate-400" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Compliance Summary */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-6">
          <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-4 flex items-center gap-2">
            <Icon name="Shield" size={20} />
            DSGVO-Compliance
          </h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-lg">
              <div className="flex items-center gap-3">
                <Icon name="CheckCircle" size={20} className="text-emerald-600" />
                <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                  Datenschutz-Richtlinien
                </span>
              </div>
              <span className="text-sm font-semibold text-emerald-600">Konform</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-lg">
              <div className="flex items-center gap-3">
                <Icon name="CheckCircle" size={20} className="text-emerald-600" />
                <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                  Einwilligungsverwaltung
                </span>
              </div>
              <span className="text-sm font-semibold text-emerald-600">Konform</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-lg">
              <div className="flex items-center gap-3">
                <Icon name="CheckCircle" size={20} className="text-emerald-600" />
                <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                  Recht auf Vergessenwerden
                </span>
              </div>
              <span className="text-sm font-semibold text-emerald-600">Konform</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
              <div className="flex items-center gap-3">
                <Icon name="AlertCircle" size={20} className="text-yellow-600" />
                <span className="text-sm font-medium text-slate-900 dark:text-slate-100">
                  Datenübertragbarkeit
                </span>
              </div>
              <span className="text-sm font-semibold text-yellow-600">Überprüfung</span>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-6">
          <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100 mb-4 flex items-center gap-2">
            <Icon name="FileText" size={20} />
            Letzte Compliance-Berichte
          </h3>
          <div className="space-y-3">
            {[
              { name: 'DSGVO Q4 2025 Bericht', date: '26.11.2025', status: 'Abgeschlossen' },
              { name: 'Sicherheitsaudit November', date: '20.11.2025', status: 'Abgeschlossen' },
              { name: 'Datenschutz-Folgenabschätzung', date: '15.11.2025', status: 'Abgeschlossen' }
            ]?.map((report, index) => (
              <div key={index} className="flex items-center justify-between p-3 bg-slate-50 dark:bg-slate-900 rounded-lg">
                <div className="flex items-center gap-3">
                  <Icon name="FileText" size={18} className="text-blue-600" />
                  <div>
                    <div className="text-sm font-medium text-slate-900 dark:text-slate-100">
                      {report?.name}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                      {report?.date}
                    </div>
                  </div>
                </div>
                <Button variant="outline" size="sm" iconName="Download">
                  Herunterladen
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuditComplianceTab;